import { CobaltActionBar } from '@cae/cobalt-react/components/action-bar';
import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltLoaderCircular } from '@cae/cobalt-react/components/loader-circular';
import * as React from 'react';

import type { EditContactActionBarProps } from './EditContactActionBar.types';

const EditContactActionBar = React.memo(
  ({
    isMobile,
    isPending,
    isProfileReady,
    isDirty,
    isPhoneValid,
    onCloseAttempt,
    onSubmit,
  }: Readonly<EditContactActionBarProps>): React.ReactElement => (
    <CobaltActionBar
      position="right"
      variant="floating"
      mobile={isMobile}
      data-heap-id="edit-contact-action-bar"
      secondaryButton={
        <CobaltButton
          data-heap-id="profile-contact-cancel-btn"
          variant="secondary"
          onClick={onCloseAttempt}
          disabled={isPending}
        >
          Cancel
        </CobaltButton>
      }
      primaryButton={
        <CobaltButton
          data-heap-id="profile-contact-save-btn"
          variant="primary"
          onClick={onSubmit}
          disabled={isPending || !isProfileReady || !isDirty || !isPhoneValid}
        >
          Save{isPending && <CobaltLoaderCircular size="small" />}
        </CobaltButton>
      }
    />
  )
);

EditContactActionBar.displayName = 'EditContactActionBar';

export { EditContactActionBar };
